// extracted by mini-css-extract-plugin
export default {"box":"TaskDescription_box__-3TQR","title":"TaskDescription_title__7odsy"};